import { createApp } from 'vue';
import VehicleResearch from './VehicleResearch.vue';

const rootEl = document.getElementById('vehicle-research-root');

if (rootEl) {
  if (rootEl.__vehicleResearchApp) {
    rootEl.__vehicleResearchApp.unmount();
    rootEl.innerHTML = '';
  }

  const app = createApp(VehicleResearch);
  app.mount(rootEl);

  rootEl.__vehicleResearchApp = app;

  if (import.meta.hot) {
    import.meta.hot.dispose(() => {
      rootEl.__vehicleResearchApp?.unmount();
      rootEl.__vehicleResearchApp = null;
      rootEl.innerHTML = '';
    });
  }
} else {
  console.warn('vehicle-research-root not found');
}
